// @ts-nocheck
import React, { FC, useRef, useCallback, useState } from 'react';
import { lory, LoryStatic } from 'lory.js';
import styled from 'styled-components';

import { Container } from 'crehana-ui/GridV2';
import Pagination from 'crehana-ui/Pagination';
import { useTranslation } from '@crehana/i18n';

import EducationApp from 'crehana-icons/EducationApp';
import Diploma from 'crehana-icons/pictograms/Diploma';
import Project from 'crehana-icons/Project';

import Feature from './components/Feature';

const SliderWrapper = styled.div`
  & div.js_slide {
    white-space: normal;
    line-height: 1.5;
    font-size: unset;
  }
`;

const Frame = styled.div`
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  white-space: nowrap;
`;

const FEATURES = [
  {
    Icon: EducationApp,
    title: 'FEATURES_TITLE_1',
    desc: 'FEATURES_DESCRIPTION_1',
  },
  {
    Icon: Project,
    title: 'FEATURES_TITLE_2',
    desc: 'FEATURES_DESCRIPTION_2',
  },
  {
    Icon: Diploma,
    title: 'FEATURES_TITLE_3',
    desc: 'FEATURES_DESCRIPTION_3',
  },
];

interface FeatureSectionProps {
  className?: string;
}

const FeatureSection: FC<FeatureSectionProps> = ({
  className = 'mt-24 sm:mt-40',
}) => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);

  const loryRef = useRef<LoryStatic>();
  const sliderRef = useCallback((node: HTMLDivElement | null) => {
    if (node) {
      const handlePagination = e => {
        setCurrentPage(e.detail.currentSlide + 1);
      };

      loryRef.current = lory(node, {
        rewind: false,
        infinite: false,
      });

      node.addEventListener('after.lory.slide', handlePagination);
    }
  }, []);

  const onPageChange = (page: number) => {
    if (loryRef.current) {
      loryRef.current.slideTo(page - 1);
    }
    setCurrentPage(page);
  };

  return (
    <Container className={className}>
      <div className="relative flex flex-col items-center sm:hidden">
        <SliderWrapper className="w-full relative">
          <div className="slider relative" ref={sliderRef}>
            <Frame className="frame js_frame inline-block relative w-full">
              <div className="slides js_slides inline-block relative w-full">
                {FEATURES.map((feature, i) => (
                  <div
                    className="js_slide inline-block relative overflow-hidden w-full"
                    key={`feature-slide-${i * 1}`}
                  >
                    <Feature
                      Icon={feature.Icon}
                      title={t(feature.title)}
                      desc={t(feature.desc)}
                    />
                  </div>
                ))}
              </div>
            </Frame>
          </div>
        </SliderWrapper>
        <Pagination
          className="w-full mt-24"
          type="dots"
          totalPages={FEATURES.length}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      </div>
      <div className="hidden sm:flex">
        {FEATURES.map((feature, i) => (
          <Feature
            key={feature.title}
            className={`w-1/3${
              i === 1
                ? ' border-l border-r border-solid border-gray-dark-56'
                : ''
            }`}
            Icon={feature.Icon}
            title={t(feature.title)}
            desc={t(feature.desc)}
          />
        ))}
      </div>
    </Container>
  );
};

export default FeatureSection;
